import React from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import PurchaseDetailsDrawer from "./Ussd/PurchaseDetailsDrawer";
import SessionDetailsDrawer from "./Ussd/SessionDetailsDrawer";
import TransportDetailsDrawer from "./Ussd/TransportDetails/TransportDetailsDrawer";
import RentalDetailsDrawer from "./Rentals/TransportDetails/RentalDetailsDrawer";
import FeedRequestDetailsDrawer from "./Ussd/FeedRequestDetailsDrawer";

const RequestDetailsDrawer = ({
  visible,
  onCancel,
  currentPage,
  setCurrentPage,
}) => {
  const { currentRequest } = useSelector((state) => state.requests);

  const [searchParams] = useSearchParams();
  const selectedTab = searchParams.get("tab");

  if (!visible) return null;

  if (selectedTab === "rentals") {
    return (
      <RentalDetailsDrawer
        key="rentals"
        visible={visible}
        onCancel={onCancel}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  }

  if (currentRequest.type === "taas") {
    return (
      <TransportDetailsDrawer
        key="taas"
        visible={visible}
        onCancel={onCancel}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  }

  if (currentRequest.type === "purchase-feed") {
    return (
      <PurchaseDetailsDrawer
        key="purchase-feed"
        visible={visible}
        onCancel={onCancel}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  }

  if (currentRequest.type === "power-africa") {
    return (
      <SessionDetailsDrawer
        key="power-africa"
        visible={visible}
        onCancel={onCancel}
      />
    );
  }

  if (
    currentRequest.type === "feed" ||
    currentRequest.type === "agri-commodity"
  ) {
    return (
      <FeedRequestDetailsDrawer
        key="agri-commodity"
        visible={visible}
        onCancel={onCancel}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    );
  }

  return null;
};

export default RequestDetailsDrawer;
